import { showDeleteConfirmation } from '@modules/common';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { switchMap, tap } from 'rxjs/operators';
import { RecursivePartial } from '@core/utils/react';
import { of } from 'rxjs';
import { GCCalendarEventRequest, GCCalendarEventResponse, GCCalendarResponse } from '@business/entities/gc_calendar';
import { GCCalendarAPI } from '@business/api/gc_calendar';

export class GCCalendarEventBloc extends BaseBloc {
  private readonly calendarRepo = new Repository<GCCalendarResponse>({
    getItemId: calendar => calendar.id,
  });

  private readonly eventsRepo = new Repository<GCCalendarEventResponse>({
    getItemId: event => event.id,
  });

  readonly calendars$ = this.calendarRepo.items$;
  readonly selectCalendar = this.calendarRepo.selectItem;

  events$ = this.eventsRepo.items$;

  onReset() {
    this.calendarRepo.reset();
  }

  //   events = (query?: Partial<GCCalendarEventRequest>) => {
  //
  //     return of([]).pipe(
  //       tap(() => {
  //         GCCalendarAPI.events(query)
  //           .pipe(this.eventsRepo.ops.upsertMany(item => ({ item })))
  //           .subscribe();
  //       }),
  //     );
  //   };

  allEvents = (query?: Partial<GCCalendarEventRequest>) => {
    return GCCalendarAPI.events(query).pipe(this.eventsRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_teams_error') }));
  };

  events = (query?: Partial<GCCalendarEventRequest>) => {
    const userIds = query?.userIds || [];
    return of([]).pipe(
      tap(() => {
        const allObs = userIds.map(socialId => GCCalendarAPI.events({ ...query, userIds: [socialId] }));
        allObs.forEach(obs => {
          obs.pipe(this.eventsRepo.ops.upsertMany(item => ({ item }))).subscribe();
        });
      }),
    );
  };

  resetEvents = () => {
    this.eventsRepo.reset();
  };

  addEvent = (event: RecursivePartial<GCCalendarEventResponse>) => {
    return GCCalendarAPI.addEvent(event).pipe(
      this.eventsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_brands_error') }),
    );
  };

  editEvent = (event: RecursivePartial<GCCalendarEventResponse>, eventId: string) => {
    return GCCalendarAPI.editEvent(event, eventId).pipe(
      this.eventsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_brands_error') }),
    );
  };

  deleteEvent = (eventId: string) => {
    return showDeleteConfirmation('Cancel event', 'Do you really want to cancel this event?').pipe(
      switchMap(() => GCCalendarAPI.deleteEvent(eventId)),
      this.eventsRepo.ops.removeOne(() => `${eventId}`),
      handleMessage({ error: requestMessage('fetch_brands_error') }),
    );
  };

  addEventToGoogleCalendar = (eventId: string) => {
    return GCCalendarAPI.addEventToGoogleCalendar(eventId).pipe(
      this.eventsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_brands_error') }),
    );
  };
}
